import React from 'react'
import BabylistReturnRequestForm from '../../../babylist-return-request-form'
import BabylistUnacceptableReturn from '../../../babylist-unacceptable-return'
import AmazonReturn from '../../../retailer-returns/amazon-return'
import WalmartReturn from '../../../retailer-returns/walmart-return'
import TargetReturn from '../../../retailer-returns/target-return'
import EtsyReturn from '../../../retailer-returns/etsy-return'
import BuyBuyBabyReturn from '../../../retailer-returns/buybuybaby-return'
import UnknownReturn from '../../../retailer-returns/unknown-return'
import { ReturnComponentForStoreProps } from './ReturnComponentForStore.types'

const ReturnComponentForStore: React.FC<ReturnComponentForStoreProps> = ({
  reservationToken,
  storeName,
  orderNum,
  daysSincePurchase,
  giftGiverName,
  giftGiverEmail,
  onSuccess,
  onFailure,
}) => {
  switch (storeName) {
    case 'Babylist':
      if (daysSincePurchase && daysSincePurchase <= 90) {
        return (
          <BabylistReturnRequestForm
            reservationToken={reservationToken}
            onFailure={onFailure}
            onSuccess={onSuccess}
          />
        )
      }
      return (
        <BabylistUnacceptableReturn daysSincePurchase={daysSincePurchase} />
      )

    case 'Amazon':
      return (
        <AmazonReturn
          giftGiverEmail={giftGiverEmail}
          giftGiverName={giftGiverName}
          orderNum={orderNum}
        />
      )

    case 'Walmart':
      return (
        <WalmartReturn
          giftGiverEmail={giftGiverEmail}
          giftGiverName={giftGiverName}
          orderNum={orderNum}
        />
      )

    case 'Target':
      return (
        <TargetReturn
          giftGiverEmail={giftGiverEmail}
          giftGiverName={giftGiverName}
          orderNum={orderNum}
        />
      )

    case 'Etsy':
      return (
        <EtsyReturn
          giftGiverEmail={giftGiverEmail}
          giftGiverName={giftGiverName}
          orderNum={orderNum}
        />
      )

    case ((storeName && storeName.match(/buy\s*buy\s*baby/i)) || {}).input:
      return (
        <BuyBuyBabyReturn
          giftGiverEmail={giftGiverEmail}
          giftGiverName={giftGiverName}
          orderNum={orderNum}
        />
      )

    default:
      return (
        <UnknownReturn
          giftGiverEmail={giftGiverEmail}
          giftGiverName={giftGiverName}
          orderNum={orderNum}
          storeName={storeName}
        />
      )
  }
}

export default ReturnComponentForStore
